import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Button from "../components/ui/Button";
import { Alert, SearchingState } from "../components/ui/Feedback";
import { trademarkApi } from "../api/trademarkApi";
import { useSearch } from "../app/SearchProvider";

/**
 * Loads a saved search into the live results view, so history and fresh
 * results are read through exactly the same screen — filters, sorting and
 * Excel export all work identically on an archived search.
 */
export default function HistoryDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadSnapshot } = useSearch();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    trademarkApi
      .getHistoryItem(id)
      .then((snapshot) => {
        if (cancelled) return;
        loadSnapshot(snapshot);
        navigate("/results", { replace: true });
      })
      .catch((err) => {
        if (!cancelled) setError(err.message);
      });

    return () => {
      cancelled = true;
    };
  }, [id, loadSnapshot, navigate]);

  if (error) {
    return (
      <div className="mx-auto max-w-[900px] px-4 py-16 sm:px-6 lg:px-8">
        <Alert tone="error" title="Couldn't open that saved search">
          {error}
        </Alert>
        <div className="mt-5">
          <Button icon={ArrowLeft} onClick={() => navigate("/history")}>
            Back to past searches
          </Button>
        </div>
      </div>
    );
  }

  return <SearchingState />;
}
